import fetch from 'auth/FetchInterceptor'

const profileService = {}

//imagen perfil

profileService.subirFotoPerfil = function (data,id = '') {
	return fetch({
		url: '/api/archivos/subirFoto/'+id,
		method: 'post',
		data: data
	})
}


profileService.volverFirmar = function (data) {
	return fetch({
		url: '/api/archivos/volverFirmar/perfil',
		method: 'get',
		data: data
	})
}


//GET INFO PERFIL

let prefix = '/api/usuarios/';

profileService.getIndividual = function (data) {
	return fetch({
		url: prefix+data.id_usuario,
		method: 'get',
		data: data
	})
}


profileService.getExtraInfo = function (id_user,params) {
	return fetch({
		url: prefix+id_user+'/info',
		method: 'get',
		params
	})
}




//RECUPERAR CONTRASEÑA

profileService.resetContrasena = function(data){
	return fetch(
		{
			url:prefix+'reset/nueva-solicitada',
			method:'post',
			headers: {
				'public-request': 'true'
			},
			data:data
		}
	)
}

profileService.CambiarContrasena = function(id,data){
	return fetch(
		{
			url:prefix+"reset/cambiar_contrasena",
			method:'post',
			data:data
		}
	)
}

profileService.verificarResetToken = function(params){
	return fetch(
		{
			headers: {
				'public-request': 'true'
			},
			url:prefix+"reset/verificarResetToken",
			method:'get',
			params
		}
	)
}




//SOLICITAR NUEVA CONTRASEÑA

profileService.solicitarContrasena = function(data){
	return fetch(
		{
			url:prefix+'reset/solicitar',
			headers: {
				'public-request': 'true'
			},
			method:'post',
			data:data
		}
	)
}

//Set password first login
profileService.setPassword = function(data){
	return fetch(
		{
			url:prefix+"reset/set-password",
			method:'post',
			data:data
		}
	)
}


export default profileService